import { format, parseISO } from "date-fns";
import { useState } from "react";

import Button from "~/components/ui/button/Button";
import Card from "~/components/ui/card/Card";

import styles from "./ClientReports.module.scss";
import ReportDeliveryModal from "./ReportDeliveryModal";
import {
  describeRecipients,
  describeSchedule,
  scheduleCoverage,
} from "./delivery";
import { ReportDelivery } from "./useReportDelivery";

type Props = {
  siteId: number;
  delivery: ReportDelivery;
};

const ReportDeliveryCard = ({ siteId, delivery }: Props) => {
  const [isEditing, setIsEditing] = useState(false);
  const { schedule, recipientNames, listLabel, canManage, isLoading, error } =
    delivery;
  const isScheduled = Boolean(schedule?.enabled);
  const isEmailed = recipientNames.length > 0 || Boolean(listLabel);

  // Members can't change anything, so there's nothing to show them until
  // an admin sets it up.
  if (isLoading || error) return null;
  if (!canManage && !isScheduled && !isEmailed) return null;

  return (
    <Card
      title="Report Delivery"
      button={
        canManage && (
          <Button outlined onClick={() => setIsEditing(true)}>
            {isScheduled || isEmailed ? "Edit" : "Set Up"}
          </Button>
        )
      }
    >
      <dl className={styles.delivery}>
        <dt>Schedule</dt>
        <dd>
          {schedule?.enabled ? (
            <>
              <strong>{describeSchedule(schedule)}</strong>, covering{" "}
              {scheduleCoverage(schedule.frequency)}. Next report on{" "}
              <strong>
                {format(parseISO(schedule.next_run_on), "EEE, MMM d, yyyy")}
              </strong>
              .
            </>
          ) : (
            "Off. Reports are only created on request."
          )}
        </dd>
        <dt>Emailed to</dt>
        <dd>
          {isEmailed
            ? describeRecipients(recipientNames, listLabel)
            : "Nobody. Reports only appear in the table below."}
        </dd>
      </dl>
      {isEditing && (
        <ReportDeliveryModal
          siteId={siteId}
          delivery={delivery}
          onClose={() => setIsEditing(false)}
        />
      )}
    </Card>
  );
};

export default ReportDeliveryCard;
